import React from 'react';
import { IPropsWithClassName } from 'interfaces';

import LoadingBox from '@atoms/LoadingBox';

import styles from './styles';

export interface NextPrevButtonsProps extends IPropsWithClassName {
  message?: string;
  bigText?: boolean;
}

const Veil = ({
  message,
  bigText = true,
}: NextPrevButtonsProps) => (
  <div className={styles.component}>
    <LoadingBox border={false} bigText={bigText} className="text-mainBlue">
      {message}
    </LoadingBox>
  </div>
);

export default Veil;
